export const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundImage: `url(${require("../../../assets/images/bg-img-5.jpg")})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    padding: "20px",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    margin: "20px",
  },
  logo: {
    width: "150px",
    height: "auto",
    maxWidth: "100%",
  },
  loginCard: {
    width: "100%",
    maxWidth: 350,
    margin: "0 auto",
  },
  loginButton: {
    width: "100%",
    marginBottom: 5,
  },
  forgotPassword: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "10px",
  },
  registerText: {
    marginTop: 25,
  },
  copyright: {
    marginTop: "20px",
    textAlign: "center" as const,
  },
};
